module.exports = __webpack_public_path__ + "media/events/RoadShowBanner-67ee6bb0.png";